import { useEffect, useMemo, useState } from 'react'
import GShell from './GShell.jsx'
import { Title, Card, Pill, Err, fmtDate } from './gui.jsx'
import { TASK_STATUSES, watchTasks, createTask, updateTask, deleteTask } from '../../lib/tasks.js'
import { watchEmployees } from '../../lib/employees.js'

export default function GTasks() {
  const [raw, setRaw] = useState({})
  const [emps, setEmps] = useState({})
  const [f, setF] = useState({ title: '', assignedTo: '', dueDate: '', notes: '' })
  const [err, setErr] = useState('')
  useEffect(() => { const a = watchTasks(setRaw), b = watchEmployees(setEmps); return () => { a(); b() } }, [])
  const rows = useMemo(() => Object.values(raw || {}).filter(Boolean).sort((a, b) => (a.status === 'Done') - (b.status === 'Done') || (a.dueDate || '').localeCompare(b.dueDate || '')), [raw])
  const empName = (id) => emps[id]?.name || 'Unassigned'
  const add = async () => { setErr(''); try { await createTask(f); setF({ title: '', assignedTo: '', dueDate: '', notes: '' }) } catch (e) { setErr(e?.message || 'Failed') } }
  return (
    <GShell>
      <Title title="Tasks" subtitle="Shop to-dos and assignments." />
      <Card>
        <div className="grid sm:grid-cols-4 gap-2">
          <input className="input sm:col-span-2" placeholder="Task title" value={f.title} onChange={(e) => setF((s) => ({ ...s, title: e.target.value }))} />
          <select className="input" value={f.assignedTo} onChange={(e) => setF((s) => ({ ...s, assignedTo: e.target.value }))}><option value="">Unassigned</option>{Object.values(emps).filter(Boolean).map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}</select>
          <input className="input" type="date" value={f.dueDate} onChange={(e) => setF((s) => ({ ...s, dueDate: e.target.value }))} />
        </div>
        <button className="btn-primary text-sm mt-2" onClick={add} disabled={!f.title.trim()}>Add Task</button>
        <Err msg={err} />
      </Card>
      <section className="pb-4 space-y-1">
        {rows.length === 0 ? <p className="text-sm text-gray-500">No tasks.</p> : rows.map((t) => (
          <Card key={t.id} className="!p-3">
            <div className="flex items-center justify-between gap-2">
              <div className="min-w-0">
                <div className={`font-bold ${t.status === 'Done' ? 'line-through text-gray-400' : ''}`} style={{ color: t.status === 'Done' ? undefined : 'var(--ge-primary)' }}>{t.title}</div>
                <div className="text-xs text-gray-500">{empName(t.assignedTo)}{t.dueDate ? ` · due ${fmtDate(t.dueDate)}` : ''}</div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <select className="input text-xs" value={t.status} onChange={(e) => updateTask(t.id, { status: e.target.value })}>{TASK_STATUSES.map((s) => <option key={s}>{s}</option>)}</select>
                <button className="text-red-600 text-xs" onClick={async () => { if (window.confirm('Delete task?')) await deleteTask(t.id) }}>✕</button>
              </div>
            </div>
          </Card>
        ))}
      </section>
    </GShell>
  )
}
